import { api } from '@goaltree/backend/convex/_generated/api'
import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import type { OptimisticLocalStore } from 'convex/browser'

type Notif = NonNullable<ReturnType<typeof listOf>>[number]

function listOf(store: OptimisticLocalStore) {
  return store.getQuery(api.notifications.list, {})
}

function markWhere(store: OptimisticLocalStore, match: (n: Notif) => boolean, all = false) {
  const list = listOf(store)
  const now = Date.now()
  let marked = 0
  if (list) {
    store.setQuery(
      api.notifications.list,
      {},
      list.map((n) => {
        if (n.readAt !== null || !match(n)) return n
        marked++
        return { ...n, readAt: now }
      }),
    )
  }
  const unread = store.getQuery(api.notifications.unreadCount, {})
  if (unread === undefined) return
  const next = all ? 0 : Math.max(0, unread - marked)
  if (next !== unread) store.setQuery(api.notifications.unreadCount, {}, next)
}

export function optimisticMarkAllRead(store: OptimisticLocalStore) {
  markWhere(store, () => true, true)
}

export function optimisticMarkRead(
  store: OptimisticLocalStore,
  { id }: { id: Id<'notificationHistory'> },
) {
  markWhere(store, (n) => n._id === id)
}

export function optimisticMarkReadByType(store: OptimisticLocalStore, { type }: { type: string }) {
  markWhere(store, (n) => n.type === type)
}
